import type { CSSProperties } from 'react';
import { T } from '@territory/tokens';

const role = (name: string, fallback: string): string => `var(--rv-${name}, ${fallback})`;
/* Exact shipped DispatchField geometry. The caller owns focus state, labels, messages and native validation. */
export function marketingDispatchFieldStyle(focused: boolean, invalid: boolean, multiline: boolean, rows: number): CSSProperties {
  return {
    width: '100%', boxSizing: 'border-box', padding: '12px 14px', borderRadius: 10,
    background: role(focused ? 'dispatch-field-focus-fill' : 'dispatch-field-fill', T.surface),
    border: `1px solid ${invalid ? T.red : focused ? T.accent : role('border', T.separator)}`,
    color: role('text', T.label), fontFamily: role('dispatch-field-font', T.font), fontSize: '1rem',
    outline: 'none', resize: multiline ? 'vertical' : 'none', minHeight: multiline ? rows * 22 : 'auto',
    transition: 'all 180ms ease',
    boxShadow: focused ? `0 0 0 3px color-mix(in srgb, ${T.accent} 13.33%, transparent)` : 'none',
    lineHeight: multiline ? 1.55 : undefined,
  };
}
